import {
  StateWithStatus,
  getInitialStateWithStatus,
  toggleStatusSuccess,
  isDefined
} from 'app/helpers';
import { THEMES } from 'app/core/tracking-page/themes';

import { TrackingPage } from './tracking-page.model';
import { toggleStatusLoading } from 'app/helpers';
import { withDefaultValues } from 'app/core';
import {
  TrackingPageActionTypes as types,
  TrackingPageActions
} from './tracking-page.actions';
import { TrackingPageDataService } from './tracking-page-data.service';

export interface TrackingPageState extends StateWithStatus {
  trackingPage: TrackingPage;
  hash: string;
  trackingPageLoaded: boolean;
  noTrackingNumberFound: string | boolean;
  reviewsEnabled: boolean;
}

const setTrackingPage = (builder) => {
  const themeId = TrackingPageDataService.getThemeId();
  if (isDefined(themeId) && isDefined(THEMES[themeId])) {
    return THEMES[themeId];
  }
  return withDefaultValues(
    builder,
    THEMES[builder.defaultThemeId || 'default']
  );
};

export const initialState: TrackingPageState = getInitialStateWithStatus({
  trackingPage: {},
  trackingPageLoaded: false,
  hash: null,
  noTrackingNumberFound: null,
  reviewsEnabled: false
});

export const trackingPageReducer = (
  state: TrackingPageState = initialState,
  action: TrackingPageActions
) => {
  switch (action.type) {
    case types.BOOTSTRAP: {
      return { ...state, hash: action.payload.hash };
    }
    case types.FIND_TRACKING_PAGE_NUMBER: {
      return toggleStatusLoading(state);
    }
    case types.BACK_TO_SEARCH: {
      return {
        ...state,
        noTrackingNumberFound: null
      };
    }
    case types.NO_TRACKING_NUMBER_FOUND: {
      return {
        ...state,
        noTrackingNumberFound: action.payload
      };
    }
    case types.SET_DEFAULT_TRACKING_PAGE: {
      return {
        ...state,
        trackingPageLoaded: true,
        trackingPage: { ...THEMES['default'] }
      };
    }
    case types.SET_TRACKING_PAGE: {
      return {
        ...state,
        trackingPageLoaded: true,
        trackingPage: setTrackingPage(
          (action.payload as any).trackingPage.builder
        )
      };
    }
    case types.BOOTSTRAP_SUCCESS: {
      const { builder } = action.payload.trackingPage;
      const trackingPage = {
        ...builder,
        sidebar: {
          ...builder.sidebar,
          sidebarField: action.payload.trackingPage.sidebarField
        }
      };
      return toggleStatusSuccess({
        ...state,
        reviewsEnabled: action.payload.trackingPage.reviewsEnabled,
        trackingPageLoaded: true,
        trackingPage: setTrackingPage(trackingPage),
        hash: action.payload.hash ?? state.hash
      });
    }
    default: {
      return state;
    }
  }
};
